import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import {
  PagamentoWithDettaglioDTO,
  getGetFrontRichiesteIdPagamentiIdRicevutaQueryOptions,
} from '@framework/api-client';
import { getNetworkErrorMessage } from '@framework/auth';
import { useAuthDownload } from '@framework/common-web';
import { useHasDocumentsInlineViewer } from '@framework/common-web/src/ui/documents/useHasDocumentsInlineViewer';
import { EnumCodStatoPagamento } from '@framework/frontoffice-submission/src/burden/payments/EnumCodStatoPagamento';
import { useTranslation } from '@framework/i18n';
import { Button, Tooltip } from 'antd';
import * as React from 'react';
import { useTheme } from 'styled-components';

interface DownloadPaymentReceiptButtonProps {
  payment: PagamentoWithDettaglioDTO;
}

export function DownloadPaymentReceiptButton(
  props: DownloadPaymentReceiptButtonProps,
) {
  const { payment } = props;
  const { t } = useTranslation();
  const hasInlineViewer = useHasDocumentsInlineViewer();
  const theme = useTheme();

  const { download, isFetching } = useAuthDownload(
    getGetFrontRichiesteIdPagamentiIdRicevutaQueryOptions,
    [payment.idRichiesta!, payment.id!],
    {
      onError: e => {
        getNetworkErrorMessage(
          e,
          t(
            'download-receipt.errore-in-download',
            'Si è verificato un problema durante il download del file',
          ),
        );
      },
      showInlineViewer: hasInlineViewer,
    },
  );

  if (payment.codStatoPagamento !== EnumCodStatoPagamento.SUCCESSO) return null;

  return (
    <Tooltip title={t('form.scarica-ricevuta', 'Scarica Ricevuta')}>
      <Button
        icon={
          !hasInlineViewer ? (
            <DownloadOutlined
              aria-label={t('form.scarica-ricevuta', 'Scarica Ricevuta')}
            />
          ) : (
            <EyeOutlined aria-label={`${theme.viewPdfLabel} Ricevuta`} />
          )
        }
        onClick={() => download()}
        disabled={!payment.id}
        loading={isFetching}
      />
    </Tooltip>
  );
}
